export function clearSession() {
  sessionStorage.clear();
}

export function isLoggedIn() {
  return Boolean(getToken()) && sessionStorage.getItem('sangramLoggedIn') === '1';
}

export function getToken() {
  return sessionStorage.getItem('sangramAuthToken') || '';
}

export function storeAuthSession(user, email, token) {
  if (token) {
    sessionStorage.setItem('sangramAuthToken', token);
  }
  sessionStorage.setItem('sangramLoggedIn', '1');
  sessionStorage.setItem('sangramUserEmail', email);
  sessionStorage.setItem('sangramUserRole', user.role);
  sessionStorage.setItem('sangramUserName', user.name || '');
  sessionStorage.setItem('sangramUserStatus', user.status || '');
  if (user.assignedZone) {
    sessionStorage.setItem('sangramAssignedZone', user.assignedZone);
  } else {
    sessionStorage.removeItem('sangramAssignedZone');
  }
}

export function getSessionStatus() {
  return sessionStorage.getItem('sangramUserStatus') || '';
}

/** Keep cached status in sync after the server reports a change (e.g. admin approval). */
export function updateSessionUser(user) {
  if (user.status) sessionStorage.setItem('sangramUserStatus', user.status);
  if (user.name) sessionStorage.setItem('sangramUserName', user.name);
  if (user.role) sessionStorage.setItem('sangramUserRole', user.role);
}

/**
 * fetch wrapper that attaches Bearer token for protected APIs.
 * On 401, clears session so ProtectedRoute can send the user back to login.
 */
export async function apiFetch(pathOrUrl, options = {}) {
  const token = getToken();
  const headers = {
    ...(options.headers || {}),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(pathOrUrl, { ...options, headers });
  if (res.status === 401) {
    clearSession();
  }
  return res;
}
